var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGuarantee3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "m7.5 10.502 1.667 1.666 3.334-3.333m4.166 2.5c0 4.167-2.916 6.25-6.383 7.458a.83.83 0 0 1-.558-.008c-3.475-1.2-6.392-3.283-6.392-7.45V5.502a.833.833 0 0 1 .833-.834c1.667 0 3.75-1 5.2-2.266a.975.975 0 0 1 1.267 0c1.458 1.275 3.533 2.266 5.2 2.266a.833.833 0 0 1 .833.834z"
})));
export default SvgGuarantee3;